module.exports = __webpack_public_path__ + "img/contact-3.496ddb5f.png";